import DuplicateActions from "@/views/Events/EventAdminDuplicates/DuplicateActions.vue";
import EventPreview from "@/components/Events/EventPreview/EventPreview.vue";
import moment from "moment/moment";
import { getIsAllDay } from "@/helpers/eventHelper";
import _ from "lodash";
export default {
  name: "EventAdminDuplicates",
  data: () => ({
    showFeatureInput: false,
    snackbarText: "",
    snackbarColor: "",
    snackbar: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    mainHeaders: [
      { text: "Name", value: "title" },
      { text: "id", value: "id" },
      { text: "Mandant", value: "principal_id" },
      { text: "Von", value: "startFormated" },
      { text: "Bis", value: "endFormated" },
      { text: "Adresse", value: "locationList" }
    ],
    subHeaders: [
      { text: "Name", value: "title" },
      { text: "id", value: "_id" },
      { text: "Mandant", value: "principal_id" },
      { text: "Von", value: "startFormated" },
      { text: "Bis", value: "endFormated" },
      { text: "Adresse", value: "locationList" },
      { text: "Aktionen", value: "actions", sortable: false }
    ],
    expanded: [],
    singleExpand: false,
    loaded: false,
    showPreviewDialog: false,
    previewedEvent: null,
    principalsById: [],
    hideMarkedDuplicates: true,
    listData: []
  }),
  async mounted() {
    try {
      if (!this.apiKeys?.length) {
        await this.$store.dispatch("getEventsConfig", {});
      }
      await this.loadStuff();
      const additionalPrincipals = [];
      this.apiKeys.forEach(ak => {
        ak.selectedPrincipals.forEach(principal => {
          //check id already exists
          if (
            additionalPrincipals.filter(p => p.id === principal.id).length > 0
          )
            return;
          additionalPrincipals.push(principal);
        });
      });
      await this.$store.dispatch("getDuplicates", {
        additionalPrincipals
      });
      this.loaded = true;
    } catch (error) {
      await this.$store.dispatch("createError", error);
    }
  },
  methods: {
    nextPage() {
      const totalItems = this.list.length;
      this.pageCount = Math.ceil(totalItems / this.itemsPerPage);
      if (this.page < this.pageCount) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    checkDuplicate(duplicate) {
      return duplicate?.apiKeys?.length > 0 || duplicate?.principal;
    },
    getPrincipalsById(id) {
      return this.principalsById[id]?.name || id;
    },
    principalsByIdRefresh() {
      const list = {};
      this.principals.forEach(principal => {
        list[principal._id] = principal;
      });
      return (this.principalsById = list);
    },
    async loadStuff() {
      //load promises async
      const promises = [];
      promises.push(this.$store.dispatch("getFeatureGroupsForEvents"));
      promises.push(this.$store.dispatch("getCategoryGroupsForEvents"));
      promises.push(
        this.$store.dispatch("getOrganizer", {
          eventList: true
        })
      );
      promises.push(this.$store.dispatch("getAllUsers"));
      await Promise.all(promises);
      this.principalsByIdRefresh();
    },
    async previewEvent(item) {
      this.previewedEvent = item;
      this.showPreviewDialog = true;
    },
    closePreview() {
      this.previewedEvent = null;
      this.showPreviewDialog = false;
    },

    createSuccess(message) {
      this.snackbarText = message;
      this.snackbarColor = "#00636C";
      this.snackbar = true;
    },
    rowClick(_, { item }) {
      const index = this.expanded.findIndex(i => i === item);
      if (index === -1) {
        this.expanded.push(item);
      } else {
        this.expanded.splice(index, 1);
      }
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    getStartEndDate(item) {
      const { start, end } = item ?? {};
      if (start) {
        if (end) return `${this.formatDate(start)} - ${this.formatDate(end)}`;
        else return this.formatDate(start);
      }
      return "";
    },
    getStartTime(item) {
      if (getIsAllDay(item)) {
        return "Ganztägig";
      }
      return moment(item.moment?.from ?? item.start).format("HH:mm");
    },
    getOrganizer(item) {
      const { operator } = item ?? {};
      if (operator && this.organizerById?.[operator])
        return this.organizerById[operator];
      return "";
    },
    getLocation(item, withLocationText = true) {
      const { location } = item ?? {};
      let returnValue = "";
      if (location && this.locationsById?.[location])
        returnValue += this.locationsById[location];
      if (item.location_text && withLocationText)
        returnValue += ` ${item.location_text}`;
      return returnValue;
    },
    getLocationCity(item) {
      return (
        item?.locationObj?.[0]?.address?.city ??
        this.locations?.find(l => l._id === item.location)?.address?.city ??
        ""
      );
    },
    updateList(item, hiddenFor, principal) {
      if (!item.duplicate) item.duplicate = {};
      // if (hiddenFor) this.$set(item.duplicate, "apiKeys", hiddenFor);
      // if (principal) this.$set(item.duplicate, "principal", principal);
      item.duplicate.principal = principal;
      item.duplicate.apiKeys = hiddenFor;
      if (!principal?.length && !hiddenFor?.length) {
        item.duplicate.principal = "";
        item.duplicate.apiKeys = [];
      }
      this.listData.reverse().reverse();
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isEventAdmin() {
      return this.currentUser?.scopes?.includes("role:events_admin");
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    apiKeys() {
      return this.$store.state?.eventConfig?.apiKeys || [];
    },
    organizer() {
      return this.$store.state.organizer;
    },
    organizerById() {
      return this.$store.state.organizerById;
    },
    locations() {
      return this.$store.state.locations;
    },
    locationsById() {
      return this.$store.state.locationsById;
    },
    featureGroups() {
      return this.$store.state.featureGroupsForEvents;
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    principals() {
      return this.$store.state.principals;
    },
    eventDuplicates() {
      return this.$store.state.eventDuplicates;
    },
    principalDuplicateGroups() {
      return this.$store.state?.eventDuplicates?.principalDuplicateGroups;
    },
    apiKeyResultDuplicateGroups() {
      return this.$store.state?.eventDuplicates?.apiKeyResultDuplicateGroups;
    },
    listPrincipalDuplicateGroups() {
      const list = [];
      if (!this.loaded || !this.principalDuplicateGroups) return list;
      this.principalDuplicateGroups.forEach(group => {
        const event = group.slice(1)?.[0];
        if (list.filter(e => e.id === event._id).length > 0) return;
        const options = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        };
        list.push({
          ...event,
          duplicate: event.duplicate || {},
          key: event.principal_id + "_" + event._id,
          id: event._id,
          title: event.title,
          startFormated: new Date(event.start).toLocaleString("de-DE", options),
          endFormated: new Date(event.end).toLocaleString("de-DE", options),
          locationList: event.locationObj?.[0]?.address,
          group: group
            .filter(f => f._id !== event._id)
            .map(i => {
              i.startFormated = new Date(i.start).toLocaleString(
                "de-DE",
                options
              );
              i.endFormated = new Date(i.end).toLocaleString("de-DE", options);
              i.locationList = i.locationObj?.[0]?.address;
              i.duplicate = i.duplicate || {};
              return i;
            })
        });
      });
      list.forEach(item => {
        item.containsMarkedDuplicates =
          this.checkDuplicate(item.duplicate) ||
          item.group.some(g => this.checkDuplicate(g.duplicate));
      });
      if (this.hideMarkedDuplicates) {
        return list.filter(e => !e.containsMarkedDuplicates);
      }
      return list;
    },
    listApiKeyResultDuplicateGroups() {
      const list = [];
      if (!this.loaded || !this.apiKeyResultDuplicateGroups) return list;
      this.apiKeyResultDuplicateGroups.forEach(group => {
        const event = group.rankedEvents.slice(1)?.[0];
        const uniqueArray = group.rankedEvents.filter(
          (obj, index, self) => index === self.findIndex(t => t.id === obj.id)
        );
        if (list.filter(e => e.id === event._id).length > 0) return;
        const options = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        };
        let apiKeys = [];
        if (group.apiKeys.length > 0) {
          apiKeys = this.apiKeys.filter(ak =>
            group.apiKeys.includes(ak.apiKey)
          );
        }

        list.push({
          ...event,
          apiKeys,
          duplicate: event.duplicate || {},
          key: event.principal_id + "_" + event._id,
          id: event._id,
          title: event.title,
          startFormated: new Date(event.start).toLocaleString("de-DE", options),
          endFormated: new Date(event.end).toLocaleString("de-DE", options),
          locationList: event.locationObj?.[0]?.address,
          group: uniqueArray.map(i => {
            i.startFormated = new Date(i.start).toLocaleString(
              "de-DE",
              options
            );
            i.endFormated = new Date(i.end).toLocaleString("de-DE", options);
            i.locationList = i.locationObj?.[0]?.address;
            return i;
          })
        });
      });
      list.forEach(item => {
        item.containsMarkedDuplicates =
          this.checkDuplicate(item.duplicate) ||
          item.group.some(g => this.checkDuplicate(g.duplicate));
      });
      if (this.hideMarkedDuplicates) {
        return list.filter(e => !e.containsMarkedDuplicates);
      }
      return list;
    },
    list() {
      if (
        !this.loaded ||
        (!this.listPrincipalDuplicateGroups &&
          !this.listApiKeyResultDuplicateGroups)
      )
        return [];
      this.listData = [];
      this.listData.push(...this.listPrincipalDuplicateGroups);
      this.listData.push(...this.listApiKeyResultDuplicateGroups);
      return this.listData;
    },
    categoryGroups() {
      return this.$store.state.categoryGroupsForEvents;
    },
    categories() {
      return _.flatten(this.categoryGroups?.map(cg => cg.categories)) ?? [];
    },
    features() {
      return (
        _.flatten(
          this.$store.state.featureGroupsForEvents?.map(fg => fg.features)
        ) ?? []
      );
    }
  },
  components: { DuplicateActions, EventPreview }
};
